var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.814 6.5L0 11.314l1.414 1.414 4.814-4.814L11.314 13l1.414-1.414L7.642 6.5l5.086-5.086L11.314 0 6.228 5.086 1.414.272 0 1.686 4.814 6.5z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0iI2ZmZiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjgxMzcxIDYuNUwwIDExLjMxMzdMMS40MTQyMSAxMi43Mjc5TDYuMjI3OTIgNy45MTQyMUwxMS4zMTM3IDEzTDEyLjcyNzkgMTEuNTg1OEw3LjY0MjE0IDYuNUwxMi43Mjc5IDEuNDE0MjFMMTEuMzEzNyAwTDYuMjI3OTIgNS4wODU3OUwxLjQxNDIxIDAuMjcyMDc4TDAgMS42ODYyOUw0LjgxMzcxIDYuNVoiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg==";
export { SvgClose as ReactComponent };